"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.target = void 0;
const hasDOM = typeof document !== 'undefined';
const target = exports.target = hasDOM ? window : {};